export default __webpack_public_path__ + "static/media/05_photo.e43b688b.jpg";